<template>
  <HeaderWrapper :headerOpened="headerOpened" :toggleHeader="toggleHeader">
    <div class="row" v-show="headerOpened">
      <ArtCounter class="order-1 w-auto flex-grow-1" />
      <div class="movements-title order-3 col-md-6">
        <h1 class="title">{{ title }}</h1>
      </div>
      <div class="top-tools w-auto col-md-3 order-2 order-md-3">
        <MenuBarUserHelp :showHelp="false" />
        <MenuBarLanguage />
      </div>
    </div>
    <div class="row mb-4" v-show="headerOpened">
      <div class="col-md-10 offset-md-2">
        <div class="movements-top">
          <div class="top-navbar">
            <MovementsAppliedFilters />
          </div>
        </div>
      </div>
    </div>
    <FilterBar />
    <FilterContent />
  </HeaderWrapper>
</template>

<script>
import FilterBar from './FilterBar.vue';
import FilterContent from './FilterContent.vue';
import ArtCounter from './ArtCounter.vue';
import MenuBarUserHelp from './MenuBarUserHelp.vue';
import MenuBarLanguage from './MenuBarLanguage.vue';
import MovementsAppliedFilters from './MovementsAppliedFilters.vue';
import HeaderWrapper from './HeaderWrapper.vue';
import { movementParameters } from 'config';

export default {
  name: 'MovementsHeader',
  components: {
    ArtCounter,
    FilterBar,
    FilterContent,
    MenuBarUserHelp,
    MenuBarLanguage,
    MovementsAppliedFilters,
    HeaderWrapper,
  },
  methods: {
    toggleHeader() {
      this.headerOpened = !this.headerOpened;
    },
  },
  computed: {
    title() {
      return movementParameters.title[this.$language.current];
    },
  },
  mounted() {
    if (this.$isMobile()) {
      this.headerOpened = false;
    }
  },
  data() {
    return {
      headerOpened: true,
    };
  },
};
</script>

<style scoped lang="less">
h1.title {
  margin-top: 5px;
  font-size: 40px;
  font-weight: 600;
}
.movements-top {
  display: inline-block;
  margin-top: 20px;
  border: 1px solid #e0e0e0;
}
.top-navbar {
  background: white;
  z-index: 98;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.25);
}
</style>

<style lang="less">
@import '~bootstrap-less-port/less/bootstrap-grid';
#media-breakpoint-down(
  lg,
  {
    .movements-title {
      display: none !important;
    }
  }
);
</style>
